import React from 'react';
import "./aisle-and-bay.scss"

function AisleAndBay({
	fulfillmentDetails
}){

	const {
		storeName,
		storeQuantity,
		isOosAtOnline,
		aisle,
		bay,
		storeStatusCode,
		nearbyInventory,
		isStoreAssortmentRestricted,
		doHideForNotifyMe,
		isLimtedStockAtStore,
		isZeroStockInLocalStoreActive,
		isZeroStockInLocalStoreBoss,
		isPurchasableInLocalStoreBoss,
		isInventoryRestricted
	} = fulfillmentDetails;
	const storeNameText = storeName && <div className="aisle-bay__store">{storeName}</div>;

	const storeQuantityText = storeQuantity > 0 &&
	  <span className="aisle-bay__in-stock aisle-bay__in-stock--spaced">
		<span className="alert-inline--success"></span>
		<span className="aisle-bay__content aisle-bay__content--spaced">
		  {" "}{storeQuantity} {" in stock"}
		</span>
	  </span>;

	const textToMeLink =
		<a id="aisleBayTooltipOpener" rel="nofollow" href="/p/svcs/taab" className="aisle-bay__link">
		 Text to Me
	    </a>;

	const aisleBay = aisle && bay &&
	  <span className="aisle-bay__content aisle-bay__content--spaced">
	    {`Aisle: ${aisle}  Bay: ${bay} `}
	  </span>;

	if(aisle && bay &&
		!nearbyInventory &&
		storeStatusCode!== '500' && storeStatusCode !== '600' &&
		!isZeroStockInLocalStoreActive &&
		!isZeroStockInLocalStoreBoss &&
		!isPurchasableInLocalStoreBoss &&
		!isStoreAssortmentRestricted &&
		!isLimtedStockAtStore &&
		(storeQuantity || !isOosAtOnline) &&
		doHideForNotifyMe &&
		!isInventoryRestricted
		){
		return (
		  <div className="aisle-bay__wrapper aisle-bay__wrapper--center aisle-bay__wrapper--hidden">
		    {storeNameText}
		    {storeQuantityText}
		    {aisleBay}
		    {textToMeLink}
		  </div>
		 );
	}else{
		return null;
	}
}
export default AisleAndBay;
